import { Controller } from "@hotwired/stimulus"
import Swiper, { Autoplay, Pagination, EffectFade } from "swiper"

export default class extends Controller {
  static targets = ["pagination"]

  connect() {
    Swiper.use([Autoplay, Pagination, EffectFade])
    this.#initSlider()
  }

  #initSlider() {
    const options = {
      pagination: {
        el: this.paginationTarget,
        clickable: true
      },
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 15
    }

    if (this.element.dataset.sliderWithColumns) {
      options.breakpoints = {
        990: {
          slidesPerGroup: 3,
          slidesPerView: 3
        }
      }
    }

    new Swiper(this.element, options)
  }
}